

































































import StInput from '@/components/basic/StInput.vue';

import { Component, Vue } from 'vue-property-decorator';
import MainMenu from '@/components/main-menu/MainMenu.vue';
import { UserStore } from '@/store/user-module';
import { MenuColorEnum } from '@/services/api/nswag/stapiclient_generated';
import { AccountStore } from '@/store/account-module';

@Component({
  components: {
    MainMenu,
    StInput,
  },
})
export default class AdministratorLayout extends Vue {
  showMenu = false;
  untouched = true;

  get dataLoaded() {
    return UserStore.dataLoaded;
  }

  async mounted() {
    this.$router.afterEach((to, from) => (this.showMenu = false));

  }

  get logoUrl() {
    return AccountStore.logo;
  }

  get menuClass() {
    return UserStore.userSettings.menuColor.toString().toLowerCase();
  }

  get lightMenu() {
    switch (UserStore.userSettings.menuColor) {
      case MenuColorEnum.Dark:
        return false;
      case MenuColorEnum.Light:
        return true;
      case MenuColorEnum.Primary:
        return !UserStore.primaryColorIsDark;
      case MenuColorEnum.Secondary:
        return !UserStore.secondaryColorIsDark;
    }
  }

  get appIsReady(): boolean {
    return AccountStore.isLoaded;
  }


  toggleMenu() {
    this.showMenu = !this.showMenu;
    this.untouched = false;
  }
}
